<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  .step-title
    span Use a referral code

  .feature-helvetica.step-explanation
    span Using a referral code is optional, however, you may miss 
    router-link.info-link.mr-5(to="/referrals", target="_blank") some useful benefits
    span if you don't have one. 
    span Don't worry, as you can set a referral code at any time later.

  .features.address-info
    .input-container
      .field.has-addons.flex-1
        .control.is-medium.is-expanded
          input.input.is-medium(
            type="text", 
            placeholder="", 
            v-model="referralCode"
          )
        .control
          a.button.is-medium(@click="select", :disabled="hasErrors", :class="{'is-success': !hasErrors}")
            span Next
      p.or OR
      button.button.is-medium.flex-1.button-continue-without(@click="continueWithoutReferral") Continue without referral code
    p.help.help-small.notif-danger(v-if="errorMessage") {{ errorMessage }}
    p.help.help-small.notif-grey(v-if="referredBySomeone")
     span Someone has sent you a link with their referral code 
     b {{ referredBySomeone }}
</template>

<script>
export default {
  name: 'c_step_referral',
  props: ['mode'],
  data () {
    return {
      referralCode: ``,
      errorMessage: ''
    }
  },
  computed: {
    referredBySomeone() {
      return this.$store.getters.ref
    },
    hasErrors () {
      let vm = this
      return vm.referralCode === ''
    }
  },
  watch: {
    referralCode: function (val) {
      var vm = this
      vm.validateInput()
    }
  },
  created () {
    let vm = this
    if (vm.referredBySomeone) {
      vm.referralCode = vm.referredBySomeone
    }
  },
  mounted () {
    document.getElementById('step').scrollIntoView();
  },
  methods : {
    validateInput () {
      let vm = this
      if (vm.referralCode.indexOf(' ') > -1) {
        vm.errorMessage = 'Your referral code must not have spaces'
      } else {
        vm.errorMessage = ''
      }
    },
    select () {
      let vm = this
      if (!vm.hasErrors) {
        vm.$emit('selected', vm.referralCode)
      }
    },
    continueWithoutReferral () {
      let vm = this
      vm.referralCode = ''
      vm.$emit('selected', vm.referralCode)
    }
  }
}
</script>

<style lang="stylus" scoped>
.input-container
  display flex
  align-items center
  margin-bottom 20px
  .field
    margin-bottom 0px
  .or
    margin 12px
    font-size 10px
    font-weight 400
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 1px;
  .button-continue-without
    width 100%
@media (max-width: 860px)
  .input-container
    flex-direction column
  

    
</style>



// WEBPACK FOOTER //
// c_step_referral.vue?049629b3